import { render, staticRenderFns } from "./ModalGraficoSala.vue?vue&type=template&id=0f2f277d&scoped=true"
import script from "./ModalGraficoSala.vue?vue&type=script&lang=js"
export * from "./ModalGraficoSala.vue?vue&type=script&lang=js"
import style0 from "./ModalGraficoSala.css?vue&type=style&index=0&id=0f2f277d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f277d",
  null
  
)

export default component.exports